export const AccessDenied = () => {
  return (
    <div className={'pt-40 w-full text-center items-center bg-black text-white h-[100vh]'}>
      <div>Access Denied.</div>
    </div>
  );
};
